module.exports = {
	name: 'CafeFactoryStore',
	provides: 'cafeFactoryStore',
	main: 'cafe_factory_store.js',
	dependencies: {
		/** @type Logger */
		logger: true,

		/** @type AudienceTrackerApi */
		trackerApi: true,

		/** @type IdleDetector */
		idleDetector: true,

		/** @type KrPanoClient */
		krPanoClient: true,

		/** @type SceneObserver */
		sceneObserver: true,

		/** @type VrModeObserver */
		vrModeObserver: true,

		/** @type Window */
		window: true,

		/** @type Document */
		document: true,

		/** @type jQuery */
		jQuery: true,

		/** @type QueryUserProvider */
		userProvider: false,

		/** @type MailNotify */
		mailNotify: true
	},
	init: 'init'
};
